import { takeLatest, put, call } from 'redux-saga/effects';
import { HTTP_HEADERS, HTTP_HEADERS_FORMDATA, HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../constants';
import request from '../../components/Utils/httpHelper';
import * as Globalconfiguration from './action';
import { CORE_API, REPORT } from '../../config';

export function* variablePredefined(action) {
    let requestUrl = `${CORE_API}/creditworthiness/config/field/predefined`;
    try {
        const result = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(Globalconfiguration.fetchVariablePredefinedSuccess(result.data));
    } catch (err) {
        yield put(Globalconfiguration.fetchVariablePredefinedFailure(err))
    }
}

export function* fetchVariablePredefinedField() {
    yield takeLatest(Globalconfiguration.FETCH_AGGREGATE_PREDEIFENED_FIELD, variablePredefined);
}

export function* aggregatePredefined(action) {
    let requestUrl = `${CORE_API}/creditworthiness/config/aggregate/predefined`;
    try {
        const result = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(Globalconfiguration.fetchAggregatePredefinedSuccess(result.data));
    } catch (err) {
        yield put(Globalconfiguration.fetchAggregatePredefinedFailure(err))
    }
}

export function* fetchAggregatePredefinedField() {
    yield takeLatest(Globalconfiguration.FETCH_AGGREGATE_PREDEIFENED_FIELD, aggregatePredefined);
}

export function* globalConfiguration(action) {
    let requestUrl = `${CORE_API}/creditworthiness/config/`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'POST', data: action.data, headers: HTTP_HEADERS });
        yield put(Globalconfiguration.saveCreditWorthinessSuccess(createResult));
    } catch (err) {
        yield put(Globalconfiguration.saveCreditWorthinessFailure(err))
    }
}

export function* createGlobalConfiguration() {
    yield takeLatest(Globalconfiguration.SAVE_CREDIT_WORTHINESS_GLOBAL_CONFIG, globalConfiguration);
}

export function* getGlobalConfiguration(action) {
    let requestUrl = `${CORE_API}/creditworthiness/config/`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(Globalconfiguration.fetchGlobalConfigurationSuccess(createResult));
    } catch (err) {
        yield put(Globalconfiguration.fetchGlobalConfigurationFailure(err))
    }
}

export function* fetchGlobalConfiguration() {
    yield takeLatest(Globalconfiguration.FETCH_GLOBAL_CONFIGURATION, getGlobalConfiguration);
}

export function* masterDataList(action) {
    let requestUrl = `${REPORT}/masterdatakey/list/${action.data.paginatedData.pageNumber}/${action.data.paginatedData.pageSize}/sort/${action.data.paginatedData.sortfield}/${action.data.paginatedData.sortDirection}`;
    try {
        const createResult = yield call(request, requestUrl, { data: action.data.requestData, method: 'POST', headers: HTTP_HEADERS });
        yield put(Globalconfiguration.getMasterDataKeySuccess(createResult.data));
    } catch (err) {
        yield put(Globalconfiguration.getMasterDataKeyFailure(err.response))
    }
}
export function* getMasterDataList() {
    yield takeLatest(Globalconfiguration.GET_MASTER_DATA_KEY_LIST, masterDataList);
}

export function* addMasterDataKey(action) {
    let requestUrl = `${REPORT}/masterdatakey/`;
    try {
        const createResult = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(Globalconfiguration.createMasterDataKeySuccess(createResult.data));
    } catch (err) {
        yield put(Globalconfiguration.createMasterDataKeyFailure(err.response))
    }
}
export function* createMasterDataKey() {
    yield takeLatest(Globalconfiguration.CREATE_MASTER_DATA_KEY, addMasterDataKey);
}

export function* xbrlMasterTemplate(action) {
    let requestUrl = `${REPORT}/xbrl/mapping/template`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(Globalconfiguration.downloadXbrlMasterTemplateSuccess(createResult.data));
    } catch (err) {
        yield put(Globalconfiguration.downloadXbrlMasterTemplateFailure(err.response))
    }
}
export function* downloadXbrlMasterTemplate() {
    yield takeLatest(Globalconfiguration.DOWNLOAD_XBRL_MASTER_TEMPLATE, xbrlMasterTemplate);
}

export function* xbrlMasterTemplateUpload(action) {
    const formData = new FormData();
    formData.append('file', action.data)
    let requestUrl = `${REPORT}/xbrl/mapping/`;
    try {
        const createResult = yield call(request, requestUrl, { data: formData, method: 'POST', headers: HTTP_HEADERS });
        yield put(Globalconfiguration.uploadXbrlMasterTemplateSuccess(createResult.data));
    } catch (err) {
        yield put(Globalconfiguration.uploadXbrlMasterTemplateFailure(err.response))
    }
}
export function* uploadXbrlMasterTemplate() {
    yield takeLatest(Globalconfiguration.UPLOAD_XBRL_MASTER_TEMPLATE, xbrlMasterTemplateUpload);
}

export function* getfetchXbrlMappingStatistics(action) {
    let requestUrl = `${REPORT}/xbrl/mapping/statistics`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(Globalconfiguration.fetchXbrlMappingStatisticsSuccess(createResult.data));
    } catch (err) {
        yield put(Globalconfiguration.fetchXbrlMappingStatisticsFailure(err.response))
    }
}
export function* fetchXbrlMappingStatistics() {
    yield takeLatest(Globalconfiguration.XBRL_MAPPING_STATISTICS, getfetchXbrlMappingStatistics);
}

export function* getMasterKeyByApiKey(action) {
    let requestUrl = `${REPORT}/masterdatakey/masterkeys/${action.data}`;
    try {
        const fetchResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(Globalconfiguration.fetchMasterKeyByApiKeySuccess(fetchResult.data));
    } catch (err) {
        yield put(Globalconfiguration.fetchMasterKeyByApiKeyFailure(err.response))
    }
}
export function* fetchMasterKeyByApiKey() {
    yield takeLatest(Globalconfiguration.FETCH_MASTERKEY_BY_APIKEY, getMasterKeyByApiKey);
}


export function* downloadBulkMasterKeyRequestTemplateSaga(action) {
    let requestUrl = `${REPORT}/masterdatakey/bulk/template`;
    try {
        const searchResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER  });
        yield put(Globalconfiguration.downloadBulkMasterKeyRequestTemplateSuccess(searchResult.data));
    } catch (err) {
        yield put(Globalconfiguration.downloadBulkMasterKeyRequestTemplateFailure(err))
    }
}
export function* getBulkMasterKeyRequestTemplate() {
    yield takeLatest(Globalconfiguration.DOWNLOAD_BULK_MASTER_KEY_REQUEST_TEMPLATE, downloadBulkMasterKeyRequestTemplateSaga);
}

export function* submitBulkMasterKeyRequestSaga(action) {
    const formData = new FormData();
    formData.append('file', action.data.file);
    let requestUrl = `${REPORT}/masterdatakey/bulk/submit`;
    try {
        const searchResult = yield call(request, requestUrl, { data: formData, method: 'POST', headers: HTTP_HEADERS_FORMDATA });
        yield put(Globalconfiguration.submitBulkMasterKeyRequestSuccess(searchResult.data));
    } catch (err) {
        yield put(Globalconfiguration.submitBulkMasterKeyRequestFailure(err))
    }
}
export function* submitBulkMasterKeyRequest() {
    yield takeLatest(Globalconfiguration.SUBMIT_BULK_MASTER_KEY_REQUEST, submitBulkMasterKeyRequestSaga);
}

export function* getApiAccessesInfo(action) {
    let requestUrl = `${REPORT}/api/allowed-access`;
    try {
        const infoResult = yield call(request, requestUrl, {data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(Globalconfiguration.fetchApiAccessesInfoSuccess(infoResult.data));
    } catch (err) {
        yield put(Globalconfiguration.fetchApiAccessesInfoFailure(err))
    }
}
export function* fetchApiAccessesInfo() {
    yield takeLatest(Globalconfiguration.API_ACCESSES_INFO, getApiAccessesInfo);
}

export function* submitApiAccessesInfo(action) {
    let requestUrl = `${REPORT}/api/manage-access`;
    try {
        const submitResult = yield call(request, requestUrl, {data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(Globalconfiguration.submitApiAccessesSuccess(submitResult.data));
    } catch (err) {
        yield put(Globalconfiguration.submitApiAccessesInfoFailure(err))
    }
}
export function* submitApiAccesses() {
    yield takeLatest(Globalconfiguration.API_ACCESSES_SUBMIT, submitApiAccessesInfo);
}

export function* getfetchApiAccessTypes(action) {
    let requestUrl = `${REPORT}/api/rubix-kyc/access-types`;
    try {
        const infoResult = yield call(request, requestUrl, {method: 'GET', headers: HTTP_HEADERS });
        yield put(Globalconfiguration.fetchApiAccessTypesSuccess(infoResult.data));
    } catch (err) {
        yield put(Globalconfiguration.fetchApiAccessTypesFailure(err))
    }
}
export function* fetchApiAccessTypes() {
    yield takeLatest(Globalconfiguration.API_ACCESS_TYPES, getfetchApiAccessTypes);
}